import { getBaseRequest, getRequest } from "@components/config/axiosClient";
import { getEndpoint } from "@components/config/helpers";
import { useRouter } from "next/router";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useBreadcrumbsInit from "../InitHooks/useBreadcrumbsInit";



const useArticle = (articleData) => {

    const router = useRouter();

    const { template_settings } = useSelector((state) => state.globalReducer);
    const { initBreadcrumbs, setLocalBreadcrumbs } = useBreadcrumbsInit();

    const isFirstRender = useRef(true);
    const loading = useRef(false);
    const initialState = useRef(true);

    const [localArticleData, setLocalArticleData] = useState(articleData)
    const [original, setOriginal] = useState({
        route: router.query.route,
        page: router?.query?.page || null,
        per_page: router?.query?.per_page || null,
        slug: router?.query?.slug || null,
        _slug_3: router?.query?._slug_3 || null,
        _slug_4: router?.query?._slug_4 || null,
        _slug_5: router?.query?._slug_5 || null,
    })

    useEffect(() => {
        initialState.current = false;
        initBreadcrumbs();
    }, [])

    const routeHasChanged = () => {
        if (
            router?.query?.route != original.route ||
            router?.query?.page != original.page ||
            router?.query?.per_page != original.per_page ||
            router?.query?.slug != original.slug ||
            router?.query?._slug_3 != original._slug_3 ||
            router?.query?._slug_4 != original._slug_4 ||
            router?.query?._slug_5 != original._slug_5
        ) {
            return true;
        }
        return false;
    }

    const buildQueryStringByType = (type, param) => {
        let str = `&${param}=`;
        if (typeof router?.query?.[type] != 'undefined' && router?.query?.[type]) {
            str += router.query[type]
        }
        else {
            str = "";
        }
        return str;
    }

    useEffect(() => {
        const handleRouteChange = async () => {
            const hasChanged = routeHasChanged();
            if ((!initialState.current) && (hasChanged)) {
                await articleReq();
            }
        };
        handleRouteChange();
    }, [router.query, router.events]);

    const articleReq = async () => {
        let obj = {
            route: router.query.route
        };
        const endpoint = await getEndpoint(obj)

        if (endpoint == null || endpoint == 'location') return;

        let queryStr = buildQueryStringByType('per_page', 'per_page');
        queryStr += buildQueryStringByType('page', 'page');
        queryStr += buildQueryStringByType('slug', 'year');
        queryStr += buildQueryStringByType('_slug_3', 'month');
        queryStr += buildQueryStringByType('_slug_4', 'day');
        queryStr += buildQueryStringByType('_slug_5', 'slug');

        loading.current = true;
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}get-articles?type=${router.query.route}${queryStr}`);
        const data = await req.json();
        setLocalBreadcrumbs(data.breadcrumb)
        setLocalArticleData(data);
        setOriginal({
            route: router.query.route,
            page: router?.query?.page || null,
            per_page: router?.query?.per_page || null,
            slug: router?.query?.slug || null,
            _slug_3: router?.query?._slug_3 || null,
            _slug_4: router?.query?._slug_4 || null,
            _slug_5: router?.query?._slug_5 || null,
        })
        loading.current = false;
    }

    return {
        localArticleData,
        loading: loading.current
    }
}

export default useArticle;